import type { SVGProps } from 'react';

const SvgTransactionFile = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clip-path="url(#clip0_1845_4584)">
      <path
        d="M8 0C10.9953 0 13.6046 1.64702 14.9756 4.08398L13.8652 5.19434L8.14941 10.9111C8.00876 11.0518 7.81804 11.1309 7.61914 11.1309C7.42024 11.1309 7.22952 11.0518 7.08887 10.9111L4.46973 8.29199C4.17684 7.99911 4.17686 7.52434 4.46973 7.23145C4.76262 6.93855 5.23738 6.93855 5.53027 7.23145L7.61914 9.32031L13.041 3.89746C11.8491 2.43471 10.034 1.5 8 1.5C4.41015 1.5 1.5 4.41015 1.5 8C1.5 11.5899 4.41015 14.5 8 14.5C11.5899 14.5 14.5 11.5899 14.5 8C14.5 7.78674 14.4869 7.57616 14.4668 7.36816L15.7637 6.07129C15.9167 6.68917 16 7.33484 16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0Z"
        fill="#AAB3CA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1845_4584">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgTransactionFile;
